import React from "react";
import { Card } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Typography } from "@material-ui/core";
const NotImplementYet = (props) => {
  return (
    <>
      <Grid
        container
        style={{ height: "50em", paddingLeft: "3em", paddingTop: "2em" }}
      >
        <Grid item>
          <Typography variant="h2">Page {props.pageName}</Typography>
          <Typography variant="h2">
            Not implement yet, pages implemented are:{" "}
          </Typography>
          <ul>
            <li>Home</li>
            <li>Services</li>
            <li>Services{" > "}Custom Software Development</li>
          </ul>
        </Grid>
      </Grid>
    </>
  );
};

export default NotImplementYet;
